<span [attr.data-cmp-vendor]="Vendors.Shopvote" id="sv-badge-t4"></span>
